export function describeProgress(
  currentNode: string,
  stepValue: number,
  stepMax: number,
  segmentTotal = 0,
): string {
  const nodeId = Number.parseInt(String(currentNode).trim(), 10)
  if (!Number.isFinite(nodeId)) return '処理中…'

  if (nodeId >= 1000 && nodeId < 2000) {
    const segmentNumber = Math.floor((nodeId - 1000) / 100) + 1
    const offset = (nodeId - 1000) % 100
    const segment = segmentTotal
      ? `Segment ${segmentNumber}/${segmentTotal}`
      : `Segment ${segmentNumber}`
    if (offset === 10) return `${segment}・High モデル step ${stepValue}/${stepMax}`
    if (offset === 11) return `${segment}・Low モデル step ${stepValue}/${stepMax}`
    if (offset === 13) return `${segment}・VAE デコード`
    return `${segment}・準備中`
  }
  if (nodeId >= 2000) return '動画を合成中（結合 / RIFE / 書き出し）'
  return 'モデル準備中'
}
